<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
  <v-container class="text-center">
    <v-form>
    <v-row>
      <v-col cols="3">
        <AdminTextField
          data-cy="FormStockItem-receivingDate"
          :label="$$t('receivingDate')"
          v-model="localDeliveryNote.receivingDate"
          v-on:keyup.enter="goNext($event.target)"
        />
      </v-col>
      <v-col cols="3">
        <v-select
          data-cy="FormStockItem-farmId"
          filled
          :label="$$t('farmId')"
          :items="farms"
          item-text="name"
          item-value="id"
          v-model="localDeliveryNote.farmId"
          v-on:keyup.enter="goNext($event.target)"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          filled
          data-cy="FormStockItem-goodsReceivedNumber"
          :label="$$t('goodsReceivedNumber')"
          v-model="localDeliveryNote.goodsReceivedNumber"
          v-on:keyup.enter="goNext($event.target)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          filled
          data-cy="FormStockItem-farmDeliveryNoteNumber"
          :label="$$t('farmDeliveryNoteNumber')"
          v-model="localDeliveryNote.farmDeliveryNoteNumber"
          v-on:keyup.enter="completedHeader"
        />
      </v-col>
    </v-row>
    </v-form>
    <v-row>
      <v-col cols="12">
        <v-btn color="success" @click="localDeliveryNote.stockItems.push({})">Add Line</v-btn>
        <table-stock-items
          ref="stockItems"
          :items="localDeliveryNote.stockItems"
          @remove="remove"
        />
      </v-col>
    </v-row>
    <v-row>
      <div class="d-flex justify-end mb-6">
        <v-btn color="default" outlined class="ml-4 btn-cancel"
          :to="{ name: from.name }"
          data-cy="FormStockItem-button-cancel">
          {{ $t('common.buttons.cancel') }}
        </v-btn>
        <v-btn color="primary" type="button" class="ml-4" :loading="isSaving" @click="save"
          data-cy="FormStockItem-button-save">
            {{ $t('common.buttons.save') }}
          </v-btn>
      </div>
    </v-row>
  </v-container>
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import TableStockItems from '../components/TableStockItems.vue';
import form from '../mixins/form';
import AdminTextField from '../components/AdminTextField.vue';

export default {
  components: {
    TableStockItems,
    AdminTextField,
  },
  name: 'NewStockItem',
  module: 'StockItem',
  mixins: [loading, form],
  data() {
    return {
      /**
      * Get/Set editing StockItem. Default to {}.
      */
      editStockItem: {},
      /**
       * Query Id for StockItem
       */
      stockItemId: this.$route?.query.id,
      localDeliveryNote: {
        receivingDate: this.formatDateTime(new Date()),
        stockItems: [{}],
      },
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('farms', ['farms']),
    productionCode() {
      const now = new Date();
      const result = `AO-${this.localDeliveryNote?.farm?.code ?? '??'}-${this.formatDate(now)}`;
      return result;
    },
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.stockItemId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_stockItem(this.stockItemId);
      this.editStockItem = this.stockItem;
    }
    this.LOAD_farms();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('farms', ['LOAD_farms', 'DELETE_farm']),
    ...mapActions('deliveryNotes', ['CREATE_deliveryNote', 'UPDATE_deliveryNote']),
    completedHeader() {
      this.$refs.stockItems.start();
    },
    remove(item) {
      this.localDeliveryNote.stockItems.splice(this.localDeliveryNote.stockItems.indexOf(item), 1);
    },
    /** Method used to save the item
     */
    async save() {
      this.isSaving = true;
      const { localDeliveryNote } = this;
      this.localDeliveryNote.receivingDate = dayjs(this.localDeliveryNote.receivingDate)
        .toISOString();
      if (this.mode === 'add') {
        await this.CREATE_deliveryNote(localDeliveryNote);
      } else {
        await this.UPDATE_deliveryNote(localDeliveryNote);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListStockItem' });
    },
  },
};
</script>
